import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {
    render() {

        const LoanIssuedDetailsInput = this.props.LoanIssuedDetailsInput;
        const LoanIssuedSearchData = this.props.LoanIssuedSearchData;
        const LoanReportTotal = this.props.LoanReportTotal;
        const LoanReportData = this.props.LoanReportData;

        return (
            <div>

                <h2><center><u>Loan Issued Within a Specific Period Report</u></center></h2>
                <div>&nbsp;</div>
                <h3><center>Group :{LoanIssuedSearchData.groupName}</center></h3>
                <h3><center>Factory :{LoanIssuedSearchData.factoryName}</center></h3>
                <h3><center>Route: {LoanIssuedSearchData.routeName===undefined?"All Routes":LoanIssuedSearchData.routeName}</center></h3>
                <h3><center>From:{LoanIssuedDetailsInput.startyear === "" ? moment(new Date()).format('YYYY') : LoanIssuedDetailsInput.startyear} / {LoanIssuedDetailsInput.startmonth === "" ? moment(new Date()).format('MMMM') : LoanIssuedSearchData.startmonth}
                    - To:{LoanIssuedDetailsInput.endyear === "" ? moment(new Date()).format('YYYY') : LoanIssuedDetailsInput.endyear}/{LoanIssuedDetailsInput.endmonth === "" ? moment(new Date()).format('MMMM') : LoanIssuedSearchData.endmonth}</center></h3>
                    <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>

                        <TableContainer >
                            <Table aria-label="caption table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Month</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Route Name</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Loan Count</TableCell>
                                        <TableCell align={'center'} style={{ border: "1px #ccc solid" }}>Loan Amount (Rs.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {LoanReportData.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {moment(new Date(data.issuedMonth)).format('MMMM')}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.routeName}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.loanCount}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.loanAmount.toLocaleString()}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <TableRow>
                                    <TableCell align={'left'} style={{ borderLeft: "1px #ccc solid" }}><b>Total</b></TableCell>
                                    <TableCell align={'left'} component="th" scope="row" ></TableCell>
                                    <TableCell align={'right'} component="th" scope="row" ></TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                        <b> {LoanReportTotal.loanAmount.toLocaleString()} </b>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );

    }

}